import { cdnData } from '@xsite-ui/common.cdn';
import { niTrackEvent } from '@xsite-ui/common.event-tracker';
import { Image } from '@xsite-ui/common.image';
import { PlaceholderTextReplace } from '@xsite-ui/common.placeholders-text-replace';
import { ComponentReport } from '@xsite-ui/common.report';
import React, { useCallback, useEffect } from 'react';
import Valid from '@xsite-ui/prequal-funnels.assets/valid';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { minDesktopWidth, mainGreen } from '@xsite-ui/prequal-funnels.constants';
import PhoneLink from '@xsite-ui/common.phone-link';

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1;
var BulletsWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  text-align: left;\n"])));
var BulletContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: baseline;\n\n  &:not(:first-of-type) {\n    margin-top: 12px;\n  }\n\n  @media (min-width: ", ") {\n    align-items: center;\n  }\n"])), minDesktopWidth);
var BulletIcon = styled.span(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  margin-right: 14px;\n  width: 17px;\n  height: 14px;\n  position: relative;\n  top: 2px;\n\n  & > * {\n    width: 17px;\n    height: 14px;\n  }\n\n  @media (min-width: ", ") {\n    position: unset;\n    top: 0;\n  }\n"])), minDesktopWidth);
var BulletText = styled.p(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 22px;\n\n  @media (min-width: ", ") {\n    font-size: 18px;\n  }\n"])), minDesktopWidth);

var Bullets = function Bullets(_ref) {
  var _ref$bullets = _ref.bullets,
      bullets = _ref$bullets === void 0 ? [] : _ref$bullets,
      handleClick = _ref.handleClick,
      cdnContextProps = _ref.cdnContextProps;
  var assetsCdn = cdnContextProps.assetsCdn,
      env = cdnContextProps.env;

  if (!bullets || bullets.length === 0) {
    return null;
  }

  var bulletsArray = bullets.map(function (bullet) {
    return {
      text: bullet.text || '',
      imgUrl: bullet.image.url || ''
    };
  });
  return /*#__PURE__*/React.createElement(BulletsWrapper, {
    "data-testid": "bullets-wrapper"
  }, bulletsArray.map(function (bullet, index) {
    var text = bullet.text,
        imgUrl = bullet.imgUrl;
    return /*#__PURE__*/React.createElement(BulletContainer, {
      key: "bullet".concat(index),
      onClick: handleClick,
      "data-testid": "bullet-container".concat(index)
    }, /*#__PURE__*/React.createElement(BulletIcon, null, imgUrl ? /*#__PURE__*/React.createElement(Image, {
      src: cdnData(imgUrl, assetsCdn, env),
      alt: "bullet icon",
      "data-testid": "bullet-icon".concat(index)
    }) : /*#__PURE__*/React.createElement(Valid, {
      color: "#1564BF",
      "data-testid": "bullet-icon".concat(index)
    })), /*#__PURE__*/React.createElement(BulletText, {
      "data-testid": "bullet-text".concat(index)
    }, text));
  }));
};

var _templateObject$1;
var PhoneContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  color: #225447;\n  border-radius: 2px;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  border: 1px solid #225447;\n\n  * {\n    font-family: inherit !important;\n  }\n\n  &:hover {\n    box-shadow: 0 4.5px 4.5px rgb(0 0 0 / 10%);\n\n    .phone-link-icon {\n      transform: rotate(35deg);\n    }\n  }\n\n  .phone-link-icon {\n    transition: transform 0.2s ease-out;\n    margin-right: 5px;\n    width: 12px;\n    height: 12px;\n    color: #49665d;\n  }\n\n  .phone-link-text {\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 600;\n    color: #49665d;\n  }\n"])));

var PhoneCta = function PhoneCta(_ref) {
  var phoneNumberAttribute = _ref.phoneNumberAttribute,
      productId = _ref.productId,
      _ref$parentComponentN = _ref.parentComponentName,
      parentComponentName = _ref$parentComponentN === void 0 ? '' : _ref$parentComponentN,
      _ref$stopPropagation = _ref.stopPropagation,
      stopPropagation = _ref$stopPropagation === void 0 ? false : _ref$stopPropagation,
      _ref$showPhoneIcon = _ref.showPhoneIcon,
      showPhoneIcon = _ref$showPhoneIcon === void 0 ? true : _ref$showPhoneIcon;
  var handlePhoneClick = useCallback(function (e) {
    if (stopPropagation) {
      e.stopPropagation();
    }

    niTrackEvent({
      category: 'Phone',
      action: 'Click',
      optLabel: parentComponentName,
      optValue: productId,
      optNonInteraction: false
    });
  }, [parentComponentName, productId]);

  var _ref2 = phoneNumberAttribute || {},
      _ref2$phoneNumber = _ref2.phoneNumber,
      phoneNumber = _ref2$phoneNumber === void 0 ? '' : _ref2$phoneNumber,
      _ref2$blrs = _ref2.blrs,
      blrs = _ref2$blrs === void 0 ? '' : _ref2$blrs;

  if (!phoneNumber) {
    return null;
  }

  return /*#__PURE__*/React.createElement(PhoneContainer, {
    onClick: handlePhoneClick,
    "data-testid": "phone-cta-container"
  }, /*#__PURE__*/React.createElement(PhoneLink, {
    phoneNumber: phoneNumber,
    showPhoneIcon: showPhoneIcon,
    "data-blrs": blrs
  }));
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
var SingleProductPageWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n"])));
var TitlesWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  text-align: center;\n  background-color: #edf4f3;\n  padding: 0 16px 112px;\n"])));
var Title = styled.h1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 32px;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 36px;\n\n  @media (min-width: ", ") {\n    margin-top: 56px;\n    font-size: 34px;\n    line-height: 48px;\n  }\n"])), minDesktopWidth);
var SubTitle = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  font-size: 18px;\n"])));
var ProductWrapperLink = styled.a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));
var ProductWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: calc(100% - 32px);\n  display: flex;\n  position: relative;\n  flex-flow: column nowrap;\n  padding: 32px 16px 24px;\n  background-color: #fff;\n  border: 1px solid #c5ecd5;\n  border-radius: 12px;\n  margin: -80px 16px 0;\n\n  @media (min-width: ", ") {\n    width: 100%;\n    margin: -65px 16px 0;\n    max-width: 950px;\n    padding: 40px 48px;\n  }\n"])), minDesktopWidth);
var ProductContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n\n  @media (min-width: ", ") {\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n"])), minDesktopWidth);
var MainContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n"])));
var ProductLogoWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n\n  @media (min-width: ", ") {\n    align-items: flex-start;\n  }\n"])), minDesktopWidth);
var LogoImgContainer = styled.a(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 180px;\n  height: 72px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  & > * {\n    width: 100%;\n  }\n\n  @media (min-width: ", ") {\n    width: 220px;\n    height: 88px;\n    object-position: left;\n  }\n"])), minDesktopWidth);
var RibbonContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n  background-color: ", ";\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n"])), mainGreen);
var BottomLine = styled.p(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  font-weight: 600;\n  font-size: 16px;\n\n  @media (min-width: ", ") {\n    font-size: 18px;\n  }\n"])), minDesktopWidth);
var CtasWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n  width: 100%;\n  max-width: 311px;\n\n  & > * {\n    cursor: pointer;\n  }\n\n  @media (min-width: ", ") {\n    max-width: 240px;\n    margin-top: unset;\n  }\n"])), minDesktopWidth);
var CtaButtonWrapper = styled.a(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius: 30px;\n  width: 100%;\n  height: 55px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n  background-color: #225447;\n  transition: 0.3s;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n\n  &:hover {\n    background-color: #0a4133;\n  }\n"])));
var CtaPhoneWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  & > div {\n    border-radius: 30px;\n    height: 55px;\n\n    @media (min-width: ", ") {\n      height: unset;\n      border: none;\n      &:hover {\n        box-shadow: unset;\n\n        & .phone-link-icon {\n          transform: unset;\n        }\n      }\n    }\n  }\n\n  & :is(p, a) {\n    font-weight: 600;\n    letter-spacing: 1px;\n    font-size: 16px;\n  }\n"])), minDesktopWidth);
styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  border: 1px solid #c5ecd5;\n  margin-top: 32px;\n  margin-bottom: 28px;\n"])));
var RecommendationsImgWrapper = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  margin-top: 32px;\n\n  & img {\n    max-width: 100%;\n  }\n\n  @media (min-width: ", ") {\n    margin-top: 40px;\n  }\n"])), minDesktopWidth);

var COMPONENT_NAME = 'popup-prequalification-wizard';
var SingleProductPageResult = function SingleProductPageResult(_ref) {
  var description = _ref.description,
      product = _ref.productToReport,
      bullets = _ref.bullets,
      bottomLine = _ref.bottomLine,
      image = _ref.image,
      cdnContextProps = _ref.cdnContextProps,
      _ref$titleText = _ref.titleText,
      titleText = _ref$titleText === void 0 ? '' : _ref$titleText,
      _ref$subTitleText = _ref.subTitleText,
      subTitleText = _ref$subTitleText === void 0 ? '' : _ref$subTitleText,
      _ref$ctaText = _ref.ctaText,
      ctaText = _ref$ctaText === void 0 ? '' : _ref$ctaText,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? '' : _ref$displayName,
      _ref$logoPath = _ref.logoPath,
      logoPath = _ref$logoPath === void 0 ? '' : _ref$logoPath,
      _ref$phoneNumberAttri = _ref.phoneNumberAttribute,
      phoneNumberAttribute = _ref$phoneNumberAttri === void 0 ? {} : _ref$phoneNumberAttri,
      legacyId = _ref.legacyId,
      geo = _ref.geo,
      userProfile = _ref.userProfile;
  var assetsCdn = cdnContextProps.assetsCdn,
      env = cdnContextProps.env;
  var logoUrl = cdnData(logoPath, assetsCdn, env);
  useEffect(function () {
    niTrackEvent({
      category: 'pre-qualification',
      action: 'Product Card Content',
      optLabel: displayName,
      optValue: 0,
      optNonInteraction: true
    });
  }, []);

  var fireUiClickEvent = function fireUiClickEvent(eventType, eventValue, e) {
    if (e) {
      e.stopPropagation();
    }

    niTrackEvent({
      category: 'pre-qualification',
      action: "click on the ".concat(eventType),
      optLabel: displayName,
      optValue: eventValue || 0,
      optNonInteraction: false
    });
  };

  return /*#__PURE__*/React.createElement(ComponentReport, {
    compName: COMPONENT_NAME,
    products: [product],
    entity: {
      productList: {
        products: [product],
        ver: '',
        varId: '',
        id: ''
      },
      id: '',
      entityType: COMPONENT_NAME
    }
  }, function (_ref2) {
    var products = _ref2.products;
    var firstProduct = products[0];
    return /*#__PURE__*/React.createElement(SingleProductPageWrapper, {
      onClick: function onClick() {
        return fireUiClickEvent('product card');
      },
      "data-testid": "single-product-page-wrapper"
    }, /*#__PURE__*/React.createElement(TitlesWrapper, null, /*#__PURE__*/React.createElement(PlaceholderTextReplace, {
      text: titleText,
      as: Title,
      commonGeo: geo,
      userProfile: userProfile,
      testId: "title-text"
    }), /*#__PURE__*/React.createElement(SubTitle, {
      "data-testid": "subtitle-text"
    }, subTitleText)), /*#__PURE__*/React.createElement(ProductWrapper, null, /*#__PURE__*/React.createElement(ProductWrapperLink, {
      onClick: function onClick(e) {
        return fireUiClickEvent('card', undefined, e);
      },
      href: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.affiliateLink,
      target: "_blank"
    }), /*#__PURE__*/React.createElement(ProductContainer, null, /*#__PURE__*/React.createElement(MainContainer, null, /*#__PURE__*/React.createElement(ProductLogoWrapper, {
      onClick: function onClick(e) {
        return fireUiClickEvent('product logo', undefined, e);
      }
    }, /*#__PURE__*/React.createElement(LogoImgContainer, {
      href: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.affiliateLink,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Image, {
      src: logoUrl,
      alt: "".concat(displayName, " logo"),
      "data-testid": "product-logo"
    })), description && /*#__PURE__*/React.createElement(RibbonContainer, {
      onClick: function onClick(e) {
        return fireUiClickEvent('product ribbon', undefined, e);
      },
      "data-testid": "ribbon-container"
    }, description)), bottomLine && /*#__PURE__*/React.createElement(BottomLine, {
      onClick: function onClick(e) {
        return fireUiClickEvent('product bottom line', undefined, e);
      },
      "data-testid": "bottomLine-text"
    }, bottomLine), /*#__PURE__*/React.createElement(Bullets, {
      bullets: bullets,
      handleClick: function handleClick(e) {
        return fireUiClickEvent('product bullets', undefined, e);
      },
      cdnContextProps: cdnContextProps
    })), /*#__PURE__*/React.createElement(CtasWrapper, null, /*#__PURE__*/React.createElement(CtaButtonWrapper, {
      onClick: function onClick(e) {
        return fireUiClickEvent('cta link', undefined, e);
      },
      href: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.affiliateLink,
      target: "_blank",
      "data-testid": "cta-btn"
    }, ctaText), (phoneNumberAttribute === null || phoneNumberAttribute === void 0 ? void 0 : phoneNumberAttribute.phoneNumber) && /*#__PURE__*/React.createElement(CtaPhoneWrapper, {
      onClick: function onClick(e) {
        return fireUiClickEvent('phone link', phoneNumberAttribute.phoneNumber, e);
      },
      "data-testid": "phone-cta-btn"
    }, /*#__PURE__*/React.createElement(PhoneCta, {
      phoneNumberAttribute: phoneNumberAttribute,
      parentComponentName: COMPONENT_NAME,
      productId: legacyId
    })))), (image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/React.createElement(RecommendationsImgWrapper, {
      onClick: function onClick(e) {
        return fireUiClickEvent('product reviews', undefined, e);
      }
    }, /*#__PURE__*/React.createElement(Image, {
      src: cdnData(image.url, assetsCdn, env),
      alt: (image === null || image === void 0 ? void 0 : image.alt) || 'product reviews',
      "data-testid": "product-reviews"
    }))));
  });
};

export { SingleProductPageResult };
